$(document).ready(function () {
	var currency = Cookies.get('currency');
      	
      //set default currency to MYR
	if (currency == null) {
		Cookies.set('currency', 'MYR');
	}
    
    $('select#currency_changer').on('change', function (e) {
		Cookies.set('currency', $(this).val());
		location.reload();
   	});

	//set select option to current currency
	$('select#currency_changer option[value=' + currency+']').attr('selected','selected');
});
